import { getStopArrival, diffLabel } from '../utils/stopArrival';

// Shows the actual arrival time next to a stop's ETA with a colour-coded
// on-time / late indicator. `dark` styles it for the dark mobile theme.
export const StopArrivalBadge = ({ stop, dark = false, className = '' }) => {
  const a = getStopArrival(stop);
  if (!a) return null;

  const tones = dark
    ? {
        early: 'text-green-400 border-green-500/40 bg-green-500/10',
        warn: 'text-amber-400 border-amber-500/40 bg-amber-500/10',
        late: 'text-red-400 border-red-500/40 bg-red-500/10',
        neutral: 'text-gray-300 border-gray-600 bg-gray-700/40',
      }
    : {
        early: 'text-green-700 border-green-300 bg-green-50',
        warn: 'text-amber-700 border-amber-300 bg-amber-50',
        late: 'text-red-700 border-red-300 bg-red-50',
        neutral: 'text-muted-foreground border-border bg-muted',
      };

  return (
    <span
      className={`inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[10px] font-medium border whitespace-nowrap ${tones[a.tone]} ${className}`}
      data-testid="stop-actual-badge"
      title={a.arrivedBy ? `Arrived by ${a.arrivedBy}` : undefined}
    >
      Actual {a.actualTime}
      {a.diffMin != null && <span>· {diffLabel(a.diffMin)}</span>}
    </span>
  );
};

export default StopArrivalBadge;
